import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import BuildingsIcon from 'static/images/buildings.svg';
import RhombsIcon from 'static/images/rhombs.svg';
import CoinIcon from 'static/images/coin-icon.svg';
import ArrowLink from 'static/images/arrow-link.svg';
import Gerb from 'static/images/Digital_gerb_russia.svg';
import NetworkObjects from 'static/images/network_objects.svg';

import './style.scss';
import clsx from 'clsx';

interface ICategoryBanners {
    category: string,
    lightDivider: number
}

export const CategoryBanners: React.FC<ICategoryBanners> = (props) => {
    const { category, lightDivider } = props;
    const { t, i18n } = useTranslation();

    const configs = useMemo(() => ({
        select: [
            {
                title: t('Имущество для МСП'),
                description: t('Имущество для бизнеса'),
                icon: <BuildingsIcon className="category-banner-icon" />,
                link: 'https://www.813.ru/podderzhka/imushchestvennaya/ploshchadki-dlya-razmeshcheniya-proizvodstv/',
                lng: [ 'ru', 'en' ]
            },
            {
                title: t('Аренда и продажа з/у. Торги'),
                description: '',
                icon: <RhombsIcon className="category-banner-icon" />,
                link: 'https://torgi.gov.ru/lotSearch1.html?bidKindId=2#',
                lng: [ 'ru', 'en' ]
            },
            {
                title: t('Тарифы'),
                description: '',
                icon: <CoinIcon className="category-banner-icon" />,
                link: 'https://tarif.lenobl.ru/ru/tarif/',
                lng: [ 'ru' ]
            },
            {
                title: t('Навигатор мер поддержки'),
                description: '',
                icon: <Gerb className="category-banner-icon" />,
                link: 'https://lenoblinvest.ru/loinav/',
                lng: [ 'ru' ]
            }
        ],
        potential: [ {
            title: t('Объекты связи'),
            description: '',
            icon: <NetworkObjects className="category-banner-icon" />,
            link: 'https://svyaz47.lenreg.ru/#/',
            lng: [ 'ru' ]
        } ]
    }), [ i18n.language ]);

    const renderBanner = (config) => {
        if (!config.lng.includes(i18n.language)) return null;
        return (
            <div
                className="category-banner"
                key={config.title}
            >
                <div className="category-banner-content">
                    <div className="category-banner-name">
                        {config.title}
                    </div>
                    <div className="category-banner-desc">
                        {config.description}
                    </div>
                    <div className="category-banner-link">
                        <a href={config.link} target="_blank" rel="noopener noreferrer">
                            <span>{t('На сайт')}</span>
                            <ArrowLink />
                        </a>
                    </div>
                </div>
                {config.icon}
            </div>
        );
    };
    return configs[category] ? (
        <>
            <div className={clsx('category-panel__divider', lightDivider > 1 && 'light')} />
            <div className="category-banners-wrapper category-panel-item collapsed">
                {configs[category].map((c) => renderBanner(c))}
            </div>
        </>
    ) : null;
};
